import CompoundInterestCalculator from "./components/compound-interest-calculator/CompoundInterestCalculator";

function App() {
  return (
    <div className="App">
      <CompoundInterestCalculator />
    </div>
  );
}

export default App;
